import { PageTitleBlock } from "../../components/PageTitleBlock/PageTitleBlock";
import styles from "./ChallengesPage.module.scss";
import { ContentWrapper } from "../../components/ContentWrapper/ContentWrapper";
import { ChallengesRoutes } from "./ChallengesRoutes";

export const ChallengesPage = () => {
    return (
        <ContentWrapper>
            <div className={styles.wrapper}>
                <PageTitleBlock pageTitle={"Испытания"} />

                <ChallengesRoutes />
            </div>
        </ContentWrapper>
    );
}